// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__2Jczn","no-border-top":"style_no-border-top__30Lm-","no-border-bottom":"style_no-border-bottom__3gr2O","content":"style_content__3RXj2"};